export default __webpack_public_path__ + "static/media/graph.3891ba0f.svg";